const listaDeDisponibilidades = (state) => {
    return state.items;
}

const loadingDisponibilidade = (state) => {
    return state.carregando
}

const paginacao = (state) => state.paginacao || null

const listaDeProvedores = (state) => {
    return state.provedores || [];
}

const disponibilidadeSelecionadaComProvedores = (state) => {
    return state.selecionado || {}
}

export {
    listaDeDisponibilidades,
    loadingDisponibilidade,
    paginacao,
    listaDeProvedores,
    disponibilidadeSelecionadaComProvedores
}

